import { AppState } from './reducers';
import { initialAdminObjectElementState } from './reducers/adminObjectReducer';
import { initialAdminObjectsElementState } from './reducers/adminObjectsReducer';

// Singleton Admin Objects
export const selectAdminObject = (state: AppState, storeId: string) => state.adminObject?.[storeId];

export const selectAdminObjectPayload = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.payload ?? initialAdminObjectElementState.payload;

export const selectAdminObjectIsPayloadInitialized = (state: AppState, storeId: string) =>
  selectAdminObjectPayload(state, storeId) !== undefined;

export const selectAdminObjectIsFetching = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.isFetching ?? initialAdminObjectElementState.isFetching;

export const selectAdminObjectFetchError = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.fetchError ?? initialAdminObjectElementState.fetchError;

export const selectAdminObjectIsSaving = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.isSaving ?? initialAdminObjectElementState.isSaving;

export const selectAdminObjectSaveError = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.saveError ?? initialAdminObjectElementState.saveError;

export const selectAdminObjectIsDeleting = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.isDeleting ?? initialAdminObjectElementState.isDeleting;

export const selectAdminObjectDeleteError = (state: AppState, storeId: string) =>
  selectAdminObject(state, storeId)?.deleteError ?? initialAdminObjectElementState.deleteError;

// Admin Object Lists
export const selectAdminObjects = (state: AppState, storeId: string) => state.adminObjects?.[storeId];

export const selectAdminObjectsPayload = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.payload ?? initialAdminObjectsElementState.payload;

export const selectAdminObjectsIsPayloadInitialized = (state: AppState, storeId: string) =>
  selectAdminObjectsPayload(state, storeId) !== undefined;

export const selectAdminObjectsIsFetching = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.isFetching ?? initialAdminObjectsElementState.isFetching;

export const selectAdminObjectsFetchError = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.fetchError ?? initialAdminObjectsElementState.fetchError;

export const selectAdminObjectsIsSaving = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.isSaving ?? initialAdminObjectsElementState.isSaving;

export const selectAdminObjectsSaveError = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.saveError ?? initialAdminObjectsElementState.saveError;

export const selectAdminObjectsIsDeleting = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.isDeleting ?? initialAdminObjectsElementState.isDeleting;

export const selectAdminObjectsDeleteError = (state: AppState, storeId: string) =>
  selectAdminObjects(state, storeId)?.deleteError ?? initialAdminObjectsElementState.deleteError;

export const selectAdminObjectsTotal = (state: AppState, storeId: string) => selectAdminObjectsPayload(state, storeId)?.total;

export const selectLoadStartedAt = (state: AppState) => state.auth.loadStartedAt;
export const selectLoadUpdatedAt = (state: AppState) => state.auth.loadUpdatedAt;
export const selectLoadStatus = (state: AppState) => state.auth.loadStatus;

export const selectAdminObjectsResults = (state: AppState, storeId: string) =>
  selectAdminObjectsPayload(state, storeId)?.results;

export const selectAdminObjectsQuery = (state: AppState, storeId: string) => selectAdminObjectsPayload(state, storeId)?.query;

export const selectAdminObjectsQueryFilters = (state: AppState, storeId: string) =>
  selectAdminObjectsQuery(state, storeId)?.filters;

// Queries.
export const selectQuery = (state: AppState, storeId: string) => state.queries[storeId];

export const selectQueryIsInitialized = (state: AppState, storeId: string) => selectQuery(state, storeId) !== undefined;

export const selectQueryFilters = (state: AppState, storeId: string) => selectQuery(state, storeId)?.filters;
